import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Rows-per-page selector used by Dashboard::PaginationComponent. The
// url-template value contains the literal placeholder "__LIMIT__",
// swapped for the selected option before navigating.
export default class extends Controller {
  static values = { urlTemplate: String }

  navigate(event) {
    const url = this.urlTemplateValue.replace("__LIMIT__", event.target.value)
    Turbo.visit(url)
  }
}
